import * as AppSettings from '@synergy/admin/app-settings/data-access';
import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { MediaReducer } from '@synergy/data-access';
import { combineReducers } from 'redux';

import { AppState } from './store/models/app-state';
import { accountReducer } from './common/reducers/account-reducers';
import { activitiesReducer } from './common/reducers/activity-reducers';
import { attributesReducer } from './common/reducers/attributes-reducers';
import { bonusSettlementsReducer } from './features/bonus-settlements/store/bonus-settlements-reducer';
import { categoryReducer } from './common/reducers/category-reducer';
import { classificationsReducer } from './features/configuration/organization/classifications/store/classifications-reducer';
import { contactReducer } from './common/reducers/contact-reducers';
import { contactsAndOrganizationsReducer } from './features/contacts-and-organizations/store/contacts-and-organizations-reducer';
import { contentManagementReducer } from './features/content-management/store/content-management-reducer';
import { currentLocaleReducer } from './common/reducers/current-locale';
import { customerReducer } from './common/reducers/customer-reducers';
import { dashboardReducer } from './features/dashboard/store/dashboard-reducers';
import { demandDetailReducer } from './features/demands/containers/detail/store/demand-detail-reducer';
import { demandsReducer } from './features/demands/demand-reducers';
import { eclassReducer } from './common/reducers/eclass-reducers';
import { importSuppliersReducer } from './features/products/import/store/suppliers/import-suppliers-reducers';
import { importsReducer } from './features/products/import/store/all/import-reducers';
import { inquiriesReducer } from './features/inquiries/inquiry-reducers';
import { internalNotesReducer } from './common/reducers/internal-notes-reducers';
import { invoiceDetailReducer } from './features/invoices/invoice-detail/store/invoice-detail-reducer';
import { invoiceNumberSequenceReducer } from './features/configuration/finance/invoice-number-sequence/store/invoice-number-sequence-reducer';
import { invoicesReducer } from './features/invoices/invoice-overview/store/invoice-reducers';
import { localeReducer } from './common/reducers/locale';
import { paymentTermsReducer } from './features/configuration/finance/payment-terms/store/payment-terms-reducer';
import { poolAccountReducer } from './common/reducers/pool-account-reducer';
import { positionsReducer } from './features/configuration/organization/positions/store/positions-reducer';
import { productReducer } from './features/products/product/store/product-reducer';
import { purchaseOrdersReducer } from './features/purchase-orders/purchase-order-reducers';
import { quickSearchReducer } from './common/reducers/quick-search-reducers';
import { resourceMissingReducer } from './common/reducers/resource-missing-reducer';
import { regionsReducer } from './common/reducers/regions-reducers';
import { salesOrdersReducer } from './features/sales-orders/sales-order-reducers';
import { selectedLanguageReducer } from './common/reducers/selected-language-reducer';
import { settingsReducer } from './common/reducers/settings-reducer';
import { supplierReducer } from './common/reducers/supplier-reducers';
import { tagReducer } from './common/reducers/tag-reducers';
import { taxRatesReducer } from './features/configuration/finance/tax-rates/store/tax-rates-reducer';
import { topicsReducer } from './features/configuration/organization/topics/store/topics-reducer';
import { transitionActivitiesReducer } from './common/reducers/transition-activities-reducers';
import { unitReducer } from './common/reducers/unit-reducers';
import { userReducer } from './common/reducers/user';

export const rootReducer = combineReducers<AppState>({
    activities: activitiesReducer,
    categories: categoryReducer,
    contacts: contactReducer,
    customers: customerReducer,
    quickSearch: quickSearchReducer,
    demands: demandsReducer,
    demandDetail: demandDetailReducer,
    inquiries: inquiriesReducer,
    invoices: invoicesReducer,
    invoiceDetail: invoiceDetailReducer,
    purchaseOrders: purchaseOrdersReducer,
    resourceMissing: resourceMissingReducer,
    currentLocale: currentLocaleReducer,
    supportedLocales: localeReducer,
    selectedLanguage: selectedLanguageReducer,
    media: MediaReducer,
    product: productReducer,
    settings: settingsReducer,
    suppliers: supplierReducer,
    units: unitReducer,
    user: userReducer,
    poolAccount: poolAccountReducer,
    salesOrders: salesOrdersReducer,
    dashboard: dashboardReducer,
    accounts: accountReducer,
    transitionActivities: transitionActivitiesReducer,
    attributes: attributesReducer,
    import: importsReducer,
    importSuppliers: importSuppliersReducer,
    tag: tagReducer,
    contactsAndOrganizations: contactsAndOrganizationsReducer,
    contentManagement: contentManagementReducer,
    eclass: eclassReducer,
    positions: positionsReducer,
    taxRates: taxRatesReducer,
    invoiceNumberSequence: invoiceNumberSequenceReducer,
    paymentTerms: paymentTermsReducer,
    classifications: classificationsReducer,
    topics: topicsReducer,
    internalNotes: internalNotesReducer,
    bonusSettlements: bonusSettlementsReducer,
    regions: regionsReducer,
    [Snackbar.name]: Snackbar.reducer,
    [AppSettings.name]: AppSettings.reducer,
});
